import React, { useState, useRef } from 'react';
import { filesize } from '@/utils';
import { FormFile } from 'react-bootstrap';

const Button = ({ text, onClick }) => (
  <button
    type="button"
    className="focus:outline-none px-4 py-1 bg-gray-600 hover:bg-gray-700 rounded-sm text-xs font-medium text-white"
    onClick={onClick}
  >
    {text}
  </button>
);

export default React.forwardRef(({ cntProps, dataBrowse, dataRemove, label, accept, custom, feedback, file, onChange, ...props }, ref) => {
  const fileInput = ref || useRef();
  //const [baseFile, setFile] = useState(file);
  const baseFile = file;

	React.useEffect(()=>{
		if (!file && fileInput.current) {
			fileInput.current.value = null;
		}
	}, [file]);

  function browse() {
    fileInput.current.click();
  }

  function remove() {
  	if (onChange) {
  		let lastValue = fileInput.current.value;
  		const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  		nativeInputValueSetter.call(fileInput.current, '');
  		const event = new Event("change", { bubbles: true });
  		event.simulated = true;
  		event.removeFile = true;
  		let tracker = fileInput.current?._valueTracker;
		if (tracker) {
		  tracker.setValue(lastValue);
		}
	    fileInput.current?.dispatchEvent(event);
  	} else {
    	fileInput.current.value = null;
  		setFile(null);
  	}
  }

  function handleFileChange(e) {
    if (!onChange) {
		const file = e.target.files[0];
		setFile(file);
	} else {
  		//const event = new Event("change");
	    //fileInput.current?.dispatchEvent(event);
	    onChange(e);
	}
  }

  return (
    <>
      {/*label && (
        <label className="form-label" htmlFor={name}>
          {label}:
        </label>
      )*/}
      <FormFile.Input
          //id={name}
          ref={fileInput}
          accept={accept}
          type="file"
          className="d-none"
          onChange={handleFileChange}
          {...props}
      />
      {custom &&
      	<>
			<div className="form-input custom-file custom d-flex py-0">
			{!baseFile && (
			  <div className="d-flex w-100 align-items-center">
				<Button text={dataBrowse||"Buscar"} onClick={browse} />
			  </div>
			)}
			{baseFile && (
			  <div className="flex items-center justify-between w-100">
				<div className="flex-1 pr-1">
				  {baseFile.name}
				  <span className="text-gray-600 text-xs ml-1">
					({filesize(baseFile.size)})
				  </span>
				</div>
				<Button text={dataRemove||"Remover"} onClick={remove} />
			  </div>
			)}
      		</div>
		</>
      }
      {feedback}
    </>
  );
});
